// @flow

import React          from 'react';
import { connect }    from 'react-redux';
import { clearFlash } from 'actions/common/flash';
import './flash.css';

const fadeFlash = (dispatch) => {
  setTimeout( () => {
    dispatch(clearFlash());
  }, 5000);
}

const Flash = ({ flash, dispatch }) => {
  if(flash.message) {
    return(
      <div
        id='alert'
        className={`alert alert-fixed alert-${flash.msgType} flash`}
        style={{ width: '90%', margin: '0 auto'}}
      >
        { flash.message }
        { fadeFlash(dispatch) }
        <button className="close" onClick={ () => dispatch(clearFlash()) }><span>&times;</span></button>
      </div>
    )
  } else {
    return null;
  }
}

const mapStateToProps = (state) => {
  return { flash: state.flash };
}

export default connect(mapStateToProps)(Flash);



// WEBPACK FOOTER //
// ./src/components/common/flash/flash.js